import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [{
    path: '/',
    redirect: '/v/blank'
  },
    // {
    //   path: '/v_index',
    //   redirect:'/v_index'
    // },
    {
      path: '/admin',
      redirect: '/gatecode'
    },
    {
      name: 'protocol',
      path: '/protocol',
      component: resolve => require(['@/components/pages/protocol.vue'], resolve)
    },
    {
      name: 'duguize',
      path: '/duguize',
      component: resolve => require(['@/components/pages/duGuize.vue'], resolve)
    },
    {
      path: '/',
      component: resolve => require(['@/components/common/Home.vue'], resolve),
      children: [
        {
          path: '/v_index',
          component: resolve => require(['@/components/pages/Index.vue'], resolve),
          meta: {title: '后台首页'}
        }, {
          path: '/medal',
          component: resolve => require(['@/components/pages/medal.vue'], resolve),
          meta: {title: '勋章'}
        }, {
          path: '/update',
          component: resolve => require(['@/components/pages/Update.vue'], resolve),
          meta: {title: '我要上新'}
        }, {
          path: '/myproduct',
          component: resolve => require(['@/components/pages/ProductList.vue'], resolve),
          meta: { title: '我的商品' }
        }, {
          path: '/recycle',
          component: resolve => require(['@/components/pages/recycleList.vue'], resolve),
          meta: { title: '回收站' }
        },{
          path: '/applyFor',
          component: resolve => require(['@/components/pages/applyFor.vue'], resolve),
          meta: { title:'申请记录' }
        },{
          path: '/distribution',
          component: resolve => require(['@/components/pages/distribution.vue'], resolve),
          meta: { title:'云仓配货' }
        },{
          path: '/backShop',
          component: resolve => require(['@/components/pages/backShop.vue'], resolve),
          meta: { title:'云仓退回' }
        },{
          path: '/inventory',
          component: resolve => require(['@/components/pages/inventory.vue'], resolve),
          meta: { title:'库存明细' }
        },{
          path: '/putin',
          component: resolve => require(['@/components/pages/putin.vue'], resolve),
          meta: { title:'入库记录' }
        },{
          path: '/deliveryrecord',
          component: resolve => require(['@/components/pages/deliveryrecord.vue'], resolve),
          meta: { title:'出库记录' }
        },{
          path: '/invoicing',
          component: resolve => require(['@/components/pages/invoicing.vue'], resolve),
          meta: { title:'进销存报表' }
        },{
          path: '/accountDetailReport',
          component: resolve => require(['@/components/pages/accountDetailReport.vue'], resolve),
          meta: { title:'入出账报表' }
        },{
          path: '/yunCangAccount',
          component: resolve => require(['@/components/pages/yunCangAccount.vue'], resolve),
          meta: { title:'云仓账户' }
        }
        ,{
          path: '/withdrawDeposit',
          component: resolve => require(['@/components/pages/withdrawDeposit.vue'], resolve),
          meta: { title:'提现' }
        }
        ,{
          path: '/squared',
          component: resolve => require(['@/components/pages/Squared.vue'], resolve),
          meta: {title: '九宫格审核'}
        }
        , {
          path: '/storesproduct',
          name: 'storesproduct',
          component: resolve => require(['@/components/pages/StoresProduct.vue'], resolve),
          meta: {title: '仓库中的商品'}
        }
        , {
          path: '/changerecord',
          component: resolve => require(['@/components/pages/changeRecord.vue'], resolve),
          meta: {title: '变更记录'}
        }

        , {
          path: '/waitforproduct',
          component: resolve => require(['@/components/pages/waitForProduct.vue'], resolve),
          meta: {title: '配货清单'}
        }, {
          path: '/showbacklist',
          component: resolve => require(['@/components/pages/showBackList.vue'], resolve),
          meta: {title: '退货清单'}
        }
        , {
          path: '/issuing',
          component: resolve => require(['@/components/pages/issuing.vue'], resolve),
          meta: {title: '商家直发订单'}
        },
        , {
          path: '/returnConfirmation',
          component: resolve => require(['@/components/pages/ReturnConfirmation.vue'], resolve),
          meta: {title: '平台退回件确认'}
        },{
          path: '/returnConfirmationReal',
          component: resolve => require(['@/components/pages/ReturnConfirmationReal.vue'], resolve),
          meta: {title: '直发退货确认'}
        },
        {
          path: '/freighttmp',
          component: resolve => require(['@/components/pages/freightTmp.vue'], resolve),
          meta: {title: '区域设置'}
        },
        {
          path: '/brandPostTemplate',
          component: resolve => require(['@/components/pages/order/brandPostTemplate.vue'], resolve),
          meta: {title: '运费模版编辑'}
        },
        {
          path: '/yunfeimoban',
          component: resolve => require(['@/components/pages/yunfeimoban.vue'], resolve),
          meta: {title: '运费模板'}
        },
        {
          path: '/expFeeTemplateList',
          component: resolve => require(['@/components/pages/expFeeTemplateList.vue'], resolve),
          meta: {title: '运费模板列表'}
        },
        {
          path: '/expFeeTemplateProcess',
          component: resolve => require(['@/components/pages/expFeeTemplateProcess.vue'], resolve),
          meta: {title: '运费模板详情'}
        },
        {
          path: '/platformafter',
          component: resolve => require(['@/components/pages/platformAfter.vue'], resolve),
          meta: {title: '平台已退商家'}
        }, {
          path: '/withdrawal',
          component: resolve => require(['@/components/pages/withdrawal.vue'], resolve),
          meta: {title: '提现'}
        }, {
          path: '/coupons',
          component: resolve => require(['@/components/pages/Coupons.vue'], resolve),
          meta: {title: '优惠券'}
        }, {
          path: '/ceatecoupons',
          component: resolve => require(['@/components/pages/Ceatecoupons.vue'], resolve),
          meta: {title: '新建优惠券'}
        }, {
          path: '/couponsdetails',
          component: resolve => require(['@/components/pages/Couponsdetails.vue'], resolve),
          meta: {title: '优惠券详情'}
        }, {
          path: '/shopDecoration',
          component: resolve => require(['@/components/pages/ShopDecoration.vue'], resolve),
          meta: {title: '店铺管理'}
        }, {
          path: '/smspromotion',
          component: resolve => require(['@/components/pages/SmsPromotion.vue'], resolve),
          meta: {title: '短信推广'}
        }, {
          path: '/advertisingpromotion',
          component: resolve => require(['@/components/pages/AdvertisingPromotion.vue'], resolve),
          meta: {title: '广告位推广'}
        }, {
          path: '/lightningshipment',
          component: resolve => require(['@/components/pages/LightningShipment.vue'], resolve),
          meta: {title: '闪电发货'}
        }, {
          path: '/salesvolume',
          component: resolve => require(['@/components/pages/SalesVolume.vue'], resolve),
          meta: {title: '店铺数据'}
        }, {
          path: '/trafficvolume',
          component: resolve => require(['@/components/pages/TrafficVolume.vue'], resolve),
          meta: {title: '网站大数据'}
        }, {
          path: '/signUp',
          component: resolve => require(['@/components/pages/activity/signUp.vue'], resolve),
          meta: {title: '活动报名'}
        }, {
          path: '/statement',
          component: resolve => require(['@/components/pages/activity/statement.vue'], resolve),
          meta: {title: '活动声明'}
        }, {
          path: '/addSign',
          component: resolve => require(['@/components/pages/activity/addSign.vue'], resolve),
          meta: {title: '添加报名商品'}
        },{
          path: '/signDetails',
          component: resolve => require(['@/components/pages/activity/signDetails.vue'], resolve),
          meta: {title: '活动概述'}
        }, {
          path: '/alreadySign',
          component: resolve => require(['@/components/pages/activity/alreadySign.vue'], resolve),
          meta: {title: '已报名活动'}
        }, {
          path: '/uploadvolume',
          component: resolve => require(['@/components/pages/UploadVolume.vue'], resolve),
          meta: {title: '上传量'}
        }, {
          path: '/activeseller',
          component: resolve => require(['@/components/pages/ActiveSeller.vue'], resolve),
          meta: {title: '活跃卖家'}
        }, {
          path: '/brandconcern',
          component: resolve => require(['@/components/pages/BrandConcern.vue'], resolve),
          meta: {title: '品牌关注'}
        }, {
          path: '/accountsreceiptsandpayments',
          component: resolve => require(['@/components/pages/AccountsReceiptsAndPayments.vue'], resolve),
          meta: {title: '账户收支'}
        },
        {
          path: '/uploadingdownloading',
          component: resolve => require(['@/components/pages/UploadingDownloading.vue'], resolve),
          meta: {title: '下载/上传记录'}
        },
         {
          path: '/duproduct',
          component: resolve => require(['@/components/pages/duProductList.vue'], resolve),
          meta: { title: '独+商品' }
        },
        {
          path: '/setprice',
          component: resolve => require(['@/components/pages/setPrice.vue'], resolve)
        },{
          path: '/set1688price',
          component: resolve => require(['@/components/pages/set1688Price.vue'], resolve)
        },
        {
          path: '/packetupload',
          component: resolve => require(['@/components/pages/PacketUpload.vue'], resolve)
        },
        {
          name: 'productdata',
          path: '/productdata',
          component: resolve => require(['@/components/pages/ProductData.vue'], resolve)
        },
        {
          name: 'packetuploaddetail',
          path: '/packetuploaddetail',
          component: resolve => require(['@/components/pages/PacketUploadDetail.vue'], resolve)
        },
        {
          name: 'accountdetails',
          path: '/accountdetails',
          component: resolve => require(['@/components/pages/AccountDetails.vue'], resolve)
        },
        {
          name: 'enterpriseQualification',
          path: '/enterpriseQualification',
          component: resolve => require(['@/components/pages/enterpriseQualification.vue'], resolve)
        },

        {
          name: 'noopen',
          path: '/noopen',
          component: resolve => require(['@/components/pages/noOpen.vue'], resolve)
        },
        {
          name: 'nozfb',
          path: '/nozfb',
          component: resolve => require(['@/components/pages/noZfb.vue'], resolve)
        },
        {
          name: 'transactionderail',
          path: '/transactionderail',
          component: resolve => require(['@/components/pages/transactionDerail.vue'], resolve)
        },
        {
          name: 'compensateDetail',
          path: '/compensateDetail',
          component: resolve => require(['@/components/pages/compensateDetail.vue'], resolve)
        }
        , {
          path: '/productscore',
          component: resolve => require(['@/components/pages/productscore.vue'], resolve),
          name: 'productscore'
        }
        , {
          path: '/brandscore',
          component: resolve => require(['@/components/pages/brandscore.vue'], resolve),
          name: 'brandscore'
        },

        {
          name: 'listdetail',
          path: '/listdetail',
          component: resolve => require(['@/components/pages/listDetail.vue'], resolve)
        },
        {
          name: 'warehousingconfirm',
          path: '/warehousingconfirm',
          component: resolve => require(['@/components/pages/warehousingConfirm.vue'], resolve)
        },
        {
          name: 'dealdetail',
          path: '/dealdetail',
          component: resolve => require(['@/components/pages/dealDetail.vue'], resolve)
        },
        {
          name: 'accountfreezedetails',
          path: '/accountfreezedetails',
          component: resolve => require(['@/components/pages/AccountFreezeDetails.vue'], resolve)
        },
        {
          name: 'redirect',
          path: '/redirect',
          component: resolve => require(['@/components/common/Redirect.vue'], resolve)
        },{
          name:'noteRecord',
          path:'/noteRecord',
          component: resolve => require(['@/components/pages/vnetshop/noteRecord.vue'], resolve)
        },
      ]
    },
    {
      path: '/admin',
      component: resolve => require(['@/components/pages/admin/AdminHome.vue'], resolve),
      children: [
        {
          path: '/logs',
          component: resolve => require(['@/components/pages/admin/logs.vue'], resolve)
        },
      ]
    },
    {
      name: 'blank',
      path: '/vnetshop/blank',
      component: resolve => require(['@/components/pages/vnetshop/blank.vue'], resolve)
    } ,
    {
      name: '/gatecode',
      path: '/gatecode',
      component: resolve => require(['@/components/pages/admin/GateCode.vue'], resolve),
      meta: { title:'档口二维码' }
    },
    {
      path: '/downloadrecord',
      component: resolve => require(['@/components/pages/admin/downloadRecord.vue'], resolve)
    },
    {
      name: '/gatecodeforself',
      path: '/gatecodeforself',
      component: resolve => require(['@/components/pages/admin/gatecodeforself.vue'], resolve),
      meta: { title:'档口二维码' }
    },
    {
      name: '/vnetshop/taobaosyn',
      path: '/vnetshop/taobaosyn',
      component: resolve => require(['@/components/pages/vnetshop/taobaoSyn.vue'], resolve),
      meta: { title:'淘宝商品管理' }
    },
    {
      name: '/brandUseStat',
      path: '/brandUseStat',
      component: resolve => require(['@/components/pages/vnetshop/brandUseStat.vue'], resolve),
      meta: { title:'商家后台使用' }
    },
    {
      name:"withdrawalCrash",
      path: '/vnetshop/withdrawalCrash',
      component: resolve => require(['@/components/pages/vnetshop/withdrawalCrash.vue'], resolve),
      meta: { title:'提现' }
    },
    {
      name: 'activitylist',
      path: '/activitylist',
      component: resolve => require(['@/components/pages/vnetshop/ActivityList.vue'], resolve)
    },
    {
      name: 'subsidyActivityList',
      path: '/subsidyActivityList',
      component: resolve => require(['@/components/pages/vnetshop/SubsidyActivityList.vue'], resolve)
    },
    {
      name: 'couponmonth',
      path: '/vnetshop/couponmonth',
      component: resolve => require(['@/components/pages/vnetshop/CouponMonth.vue'], resolve)
    },
    , {
      path: '/vnetshop/brandscorevnetshop',
      component: resolve => require(['@/components/pages/vnetshop/brandscorevnetshop.vue'], resolve),
      name: 'brandscorevnetshop'
    }
    , {
      path: '/vnetshop/productscorevnetshop',
      component: resolve => require(['@/components/pages/vnetshop/productscorevnetshop.vue'], resolve),
      name: 'productscorevnetshop'
    },
    {
      name: 'couponmonthDetail',
      path: '/vnetshop/couponmonthDetail',
      component: resolve => require(['@/components/pages/vnetshop/CouponMonthDetail.vue'], resolve)
    },
    {
      name: 'couponmonthList',
      path: '/vnetshop/couponmonthList',
      component: resolve => require(['@/components/pages/vnetshop/CouponMonthList.vue'], resolve)
    },
    {
      name: 'laxinList',
      path: '/vnetshop/laxinList',
      component: resolve => require(['@/components/pages/vnetshop/laxinList.vue'], resolve)
    },
    {
      name: 'sysChangeRecord',
      path: '/vnetshop/changerecord',
      component: resolve => require(['@/components/pages/vnetshop/sysChangeRecord.vue'], resolve)
    },
    {
      name: 'advertisement',
      path: '/vnetshop/advertisement',
      component: resolve => require(['@/components/pages/vnetshop/Advertisement.vue'], resolve)
    },
      {
      name: 'advertisementEdit',
      path: '/vnetshop/advertisementedit',
      component: resolve => require(['@/components/pages/vnetshop/AdvertisementEdit.vue'], resolve)
    },
    {
      name: 'adManageList',
      path: '/vnetshop/adManageList',
      component: resolve => require(['@/components/pages/vnetshop/AdManageList.vue'], resolve)
    },
    {
      name: 'duExamineList',
      path: '/vnetshop/duExamineList',
      component: resolve => require(['@/components/pages/vnetshop/duExamineList.vue'], resolve)
    },
    {
      name: 'sweepstakesList',
      path: '/vnetshop/sweepstakesList',
      component: resolve => require(['@/components/pages/vnetshop/sweepstakesList.vue'], resolve)
    },
    {
      name: 'checkCertificate',
      path: '/vnetshop/checkCertificate',
      component: resolve => require(['@/components/pages/checkCertificate.vue'], resolve)
    },
    {
      name: 'adManageEdit',
      path: '/vnetshop/adManageEdit',
      component: resolve => require(['@/components/pages/vnetshop/AdManageEdit.vue'], resolve)
    },
    {
      name: 'lookover',
      path: '/lookover',
      component: resolve => require(['@/components/pages/vnetshop/LookOver.vue'], resolve)
    },
    {
      name: 'subsidyLookOver',
      path: '/subsidyLookOver',
      component: resolve => require(['@/components/pages/vnetshop/SubsidyLookOver.vue'], resolve)
    },
    {
      name: 'allproductslist',
      path: '/allproductslist',
      component: resolve => require(['@/components/pages/vnetshop/allproductslist.vue'], resolve)
    },  {
      name: '/vnetshop/advertisingView',
      path: '/vnetshop/advertisingView',
      component: resolve => require(['@/components/pages/vnetshop/advertisingView.vue'], resolve)
    },{
      name: '/vnetshop/advertisingRecord',
      path: '/vnetshop/advertisingRecord',
      component: resolve => require(['@/components/pages/vnetshop/advertisingRecord.vue'], resolve)
    }, {
      name: '/vnetshop/advertisingAdd',
      path: '/vnetshop/advertisingAdd',
      component: resolve => require(['@/components/pages/vnetshop/advertisingAdd.vue'], resolve)
    }, {
      name: 'editShop',
      path: '/editShop',
      component: resolve => require(['@/components/pages/vnetshop/EditShop.vue'], resolve)
    },
    {
      name: 'addactivities',
      path: '/addactivities',
      component: resolve => require(['@/components/pages/vnetshop/AddActivities.vue'], resolve)
    },
    {
      name: 'subsidyAddActivities',
      path: '/subsidyAddActivities',
      component: resolve => require(['@/components/pages/vnetshop/SubsidyAddActivities.vue'], resolve)
    },
    {
      name: 'audit',
      path: '/audit',
      component: resolve => require(['@/components/pages/vnetshop/Audit.vue'], resolve)
    },
    {
      name: 'auditscan',
      path: '/auditscan',
      component: resolve => require(['@/components/pages/vnetshop/AuditScan.vue'], resolve)
    }
    ,{
      path: '/vnetshop/freightTmpvnetshop',
      component: resolve => require(['@/components/pages/vnetshop/freightTmpvnetshop.vue'], resolve),
      name: 'freightTmpvnetshop'
    },{
      path: '/vnetshop/yunfeimobanvnetshop',
      component: resolve => require(['@/components/pages/vnetshop/yunfeimobanvnetshop.vue'], resolve),
      name: 'yunfeimobanvnetshop'
    },
    {
      name: 'manualrelease',
      path: '/manualrelease',
      component: resolve => require(['@/components/pages/ManualRelease.vue'], resolve)
    },
    {
      name: 'edit',
      path: '/edit',
      component: resolve => require(['@/components/pages/Edit.vue'], resolve)
    },
    {
      name: 'moreset',
      path: '/moreset',
      component: resolve => require(['@/components/pages/moreSet.vue'], resolve)
    },
    {
      name: 'helppdf',
      path: '/helppdf',
      component: resolve => require(['@/components/pages/helpPdf.vue'], resolve)
    },
    {
      path: '/productdata',
      component: resolve => require(['@/components/pages/ProductData.vue'], resolve)
    },
    {
      path: '/shoptype',
      component: resolve => require(['@/components/pages/shopType.vue'], resolve)
    },
    {
      path: '/fillmessage',
      component: resolve => require(['@/components/pages/fillMessage.vue'], resolve)
    },
    {
      path: '/fillmessage1',
      component: resolve => require(['@/components/pages/fillMessage1.vue'], resolve)
    },
    {
      path: '/fillmessage2',
      component: resolve => require(['@/components/pages/fillMessage2.vue'], resolve)
    },
    {
      path: '/fillmessage3',
      component: resolve => require(['@/components/pages/fillMessage3.vue'], resolve)
    },
    {
      name: 'editsuccess',
      path: '/editsuccess',
      component: resolve => require(['@/components/pages/Editsuccess.vue'], resolve)
    },
    {
      path: '/v/login',
      component: resolve => require(['@/components/pages/Login.vue'], resolve)
    },
    {
      path: '/v/taobaologin',
      component: resolve => require(['@/components/pages/TaoBaoLogin.vue'], resolve)
    },
    {
      path: '/v/blank',
      component: resolve => require(['@/components/pages/blank.vue'], resolve)
    },
    {
      path: '/publish/product/rule',
      component: resolve => require(['@/components/pages/rule.vue'], resolve)
    },
    {
      path: '/error',
      name: 'error',
      component: resolve => require(['@/components/pages/common/error.vue'], resolve),
      meta: {title: '错误'}
    },
    {
      path: '/vnetshop/error',
      name: 'vnetshoperror',
      component: resolve => require(['@/components/pages/vnetshop/error.vue'], resolve),
      meta: {title: '错误'}
    },
    {
      name: '/vnetshop/salebacklist',
      path: '/vnetshop/salebacklist',
      component: resolve => require(['@/components/pages/vnetshop/salebacklist.vue'], resolve)
    },
    {
      name: '/vnetshop/salebackgroup',
      path: '/vnetshop/salebackgroup',
      component: resolve => require(['@/components/pages/vnetshop/salebackgroup.vue'], resolve)
    },
    {
      name:'/vnetshop/qrcodemanage',
      path:'/vnetshop/qrcodemanage',
      component: resolve => require(['@/components/pages/vnetshop/qrcodeManage.vue'], resolve)
    },
    {
      name:'/vnetshop/qrcodescancount',
      path:'/vnetshop/qrcodescancount',
      component: resolve => require(['@/components/pages/vnetshop/qrcodeScanCount.vue'], resolve)
    },
    {
      name:'/vnetshop/qrcodescandetail',
      path:'/vnetshop/qrcodescandetail',
      component: resolve => require(['@/components/pages/vnetshop/qrcodeScanDetail.vue'], resolve)
    },
    {
      name:'/vnetshop/brandreturncash',
      path:'/vnetshop/brandreturncash',
      component: resolve => require(['@/components/pages/vnetshop/brandReturnCash.vue'], resolve)
    },
    {
      name:'/vnetshop/newautoindex',
      path:'/vnetshop/newautoindex',
      component: resolve => require(['@/components/pages/vnetshop/newAutoIndex.vue'], resolve)
    },
    {
      name:'/vnetshop/newautolist',
      path:'/vnetshop/newautolist',
      component: resolve => require(['@/components/pages/vnetshop/newAutoList.vue'], resolve)
    },
    {
      name:'/vnetshop/newautodetails',
      path:'/vnetshop/newautodetails',
      component: resolve => require(['@/components/pages/vnetshop/newAutoDetails.vue'], resolve)
    },
    {
      name:'/vnetshop/groupactivitylist',
      path:'/vnetshop/groupactivitylist',
      component: resolve => require(['@/components/pages/vnetshop/groupActivityList.vue'], resolve)
    },
    {
      name:'/vnetshop/preference',
      path:'/vnetshop/preference',
      component: resolve => require(['@/components/pages/vnetshop/preference.vue'], resolve)
    },
    {
      name:'/vnetshop/groupaddActivity',
      path:'/vnetshop/groupaddActivity',
      component: resolve => require(['@/components/pages/vnetshop/groupAddActivity.vue'], resolve)
    },{
      name:'/vnetshop/groupeditActivity',
      path:'/vnetshop/groupeditActivity',
      component: resolve => require(['@/components/pages/vnetshop/groupEditActivity.vue'], resolve)
    }
    ,{
      name:'/vnetshop/groupdetailActivity',
      path:'/vnetshop/groupdetailActivity',
      component: resolve => require(['@/components/pages/vnetshop/groupDetailActivity.vue'], resolve)
    },
    {
      name:'/vnetshop/groupaddshop',
      path:'/vnetshop/groupaddshop',
      component: resolve => require(['@/components/pages/vnetshop/groupAddShop.vue'], resolve)
    },
    {
      name:'/vnetshop/buyerlabel',
      path:'/vnetshop/buyerlabel',
      component: resolve => require(['@/components/pages/vnetshop/buyerLabel.vue'], resolve)
    },{
      name:'/vnetshop/grouppanel',
      path:'/vnetshop/grouppanel',
      component: resolve => require(['@/components/pages/vnetshop/groupPanel.vue'], resolve)
    },{
      name:'/vnetshop/groupregulate',
      path:'/vnetshop/groupregulate',
      component: resolve => require(['@/components/pages/vnetshop/groupRegulate.vue'], resolve)
    },{
      name:'/vnetshop/pushControl',
      path:'/vnetshop/pushControl',
      component: resolve => require(['@/components/pages/vnetshop/pushControl.vue'], resolve)
    }
    ,{
      name:'/vnetshop/preferenceStats',
      path:'/vnetshop/preferenceStats',
      component: resolve => require(['@/components/pages/vnetshop/preferenceStats.vue'], resolve)
    },
    {
      name:'/vnetshop/newMemberList',
      path:'/vnetshop/newMemberList',
      component: resolve => require(['@/components/pages/vnetshop/newMemberList.vue'], resolve)
    }
    ,{
      name:'/vnetshop/notetype',
      path:'/vnetshop/notetype',
      component: resolve => require(['@/components/pages/vnetshop/noteType.vue'], resolve)
    },
    {
      name:'/vnetshop/chnnotetype',
      path:'/vnetshop/chnnotetype',
      component: resolve => require(['@/components/pages/vnetshop/chn/chnNoteType.vue'], resolve)
    }, {
      name:'/vnetshop/chnaddnotegenre',
      path:'/vnetshop/chnaddnotegenre',
      component: resolve => require(['@/components/pages/vnetshop/chn/chnAddNoteGenre.vue'], resolve)
    }
    , {
      name:'/vnetshop/chnaddnotegenrerealtime',
      path:'/vnetshop/chnaddnotegenrerealtime',
      component: resolve => require(['@/components/pages/vnetshop/chn/chnAddNoteGenreRealTime.vue'], resolve)
    } , {
      name:'/vnetshop/chneditnotegenrerealtime',
      path:'/vnetshop/chneditnotegenrerealtime',
      component: resolve => require(['@/components/pages/vnetshop/chn/chnEditNoteGenreRealTime.vue'], resolve)
    }, {
      name:'/vnetshop/chnviewnotegenrerealtime',
      path:'/vnetshop/chnviewnotegenrerealtime',
      component: resolve => require(['@/components/pages/vnetshop/chn/chnViewNoteGenreRealTime.vue'], resolve)
    }
    ,
    {
      name:'/vnetshop/chneditnotegenre',
      path:'/vnetshop/chneditnotegenre',
      component: resolve => require(['@/components/pages/vnetshop/chn/chnEditNoteGenre.vue'], resolve)
    },
    {
      name:'/vnetshop/chnviewnotegenre',
      path:'/vnetshop/chnviewnotegenre',
      component: resolve => require(['@/components/pages/vnetshop/chn/chnViewNoteGenre.vue'], resolve)
    },
    {
      name:'/vnetshop/userdetails',
      path:'/vnetshop/userdetails',
      component: resolve => require(['@/components/pages/vnetshop/chn/userdetails.vue'], resolve)
    },
    {
      name:'/vnetshop/pushCount',
      path:'/vnetshop/pushCount',
      component: resolve => require(['@/components/pages/vnetshop/pushCount.vue'], resolve)
    },
    {
      name:'/vnetshop/chnpushcount',
      path:'/vnetshop/chnpushcount',
      component: resolve => require(['@/components/pages/vnetshop/chn/chnPushCount.vue'], resolve)
    },
    {
      name:'/vnetshop/navConfiguration',
      path:'/vnetshop/navConfiguration',
      component: resolve => require(['@/components/pages/vnetshop/navConfiguration.vue'], resolve)
    },
    {
      name:'/vnetshop/groupCount',
      path:'/vnetshop/groupCount',
      component: resolve => require(['@/components/pages/vnetshop/groupCount.vue'], resolve)
    },
    {
      name:'/vnetshop/customOrderTrend',
      path:'/vnetshop/customOrderTrend',
      component: resolve => require(['@/components/pages/vnetshop/customOrderTrend.vue'], resolve)
    },
    {
      name:'/vnetshop/storageRegerCount',
      path:'/vnetshop/storageRegerCount',
      component: resolve => require(['@/components/pages/vnetshop/storageRegerCount.vue'], resolve)
    },
    {
      name:'/vnetshop/notestencil',
      path:'/vnetshop/notestencil',
      component: resolve => require(['@/components/pages/vnetshop/noteStencil.vue'], resolve)
    },{
      name:'/vnetshop/notetask',
      path:'/vnetshop/notetask',
      component: resolve => require(['@/components/pages/vnetshop/noteTask.vue'], resolve)
    },{
      name:'/vnetshop/chnnotetask',
      path:'/vnetshop/chnnotetask',
      component: resolve => require(['@/components/pages/vnetshop/chn/chnNoteTask.vue'], resolve)
    },{
      name:'/vnetshop/notecreation',
      path:'/vnetshop/notecreation',
      component: resolve => require(['@/components/pages/vnetshop/noteCreation.vue'], resolve)
    },{
      name:'/vnetshop/chnnotecreation',
      path:'/vnetshop/chnnotecreation',
      component: resolve => require(['@/components/pages/vnetshop/chn/chnNoteCreation.vue'], resolve)
    },{
      name:'/vnetshop/notedetails1',
      path:'/vnetshop/notedetails1',
      component: resolve => require(['@/components/pages/vnetshop/noteDetails1.vue'], resolve)
    },{
      name:'/vnetshop/chnnotedetails1',
      path:'/vnetshop/chnnotedetails1',
      component: resolve => require(['@/components/pages/vnetshop/chn/chnNoteDetails1.vue'], resolve)
    },{
      name:'/vnetshop/notedetails2',
      path:'/vnetshop/notedetails2',
      component: resolve => require(['@/components/pages/vnetshop/noteDetails2.vue'], resolve)
    },{
      name:'/vnetshop/chnnotedetails2',
      path:'/vnetshop/chnnotedetails2',
      component: resolve => require(['@/components/pages/vnetshop/chn/chnNoteDetails2.vue'], resolve)
    },{
      name:'/vnetshop/notedetails3',
      path:'/vnetshop/notedetails3',
      component: resolve => require(['@/components/pages/vnetshop/noteDetails3.vue'], resolve)
    },{
      name:'/vnetshop/chnnotedetails3',
      path:'/vnetshop/chnnotedetails3',
      component: resolve => require(['@/components/pages/vnetshop/chn/chnNoteDetails3.vue'], resolve)
    },{
      name:'/vnetshop/chnnotedetails4',
      path:'/vnetshop/chnnotedetails4',
      component: resolve => require(['@/components/pages/vnetshop/chn/chnNoteDetails4.vue'], resolve)
    }, {
      name:'/vnetshop/noterecord',
      path:'/vnetshop/noterecord',
      component: resolve => require(['@/components/pages/vnetshop/noteRecord.vue'], resolve)
    },{
      name:'/vnetshop/notegenre1',
      path:'/vnetshop/notegenre1',
      component: resolve => require(['@/components/pages/vnetshop/noteGenre1.vue'], resolve)
    },{
      name:'/vnetshop/notegenre2',
      path:'/vnetshop/notegenre2',
      component: resolve => require(['@/components/pages/vnetshop/noteGenre2.vue'], resolve)
    },{
      name:'/vnetshop/notegenre3',
      path:'/vnetshop/notegenre3',
      component: resolve => require(['@/components/pages/vnetshop/noteGenre3.vue'], resolve)
    },{
      name:'/vnetshop/crmmember',
      path:'/vnetshop/crmmember',
      component: resolve => require(['@/components/pages/vnetshop/crmMember.vue'], resolve)
    },{
      name:'/vnetshop/followup2',
      path:'/vnetshop/followup2',
      component: resolve => require(['@/components/pages/vnetshop/followUp2.vue'], resolve)
    },{
      name:'/vnetshop/followup3',
      path:'/vnetshop/followup3',
      component: resolve => require(['@/components/pages/vnetshop/followUp3.vue'], resolve)
    },{
      name:'/vnetshop/crmFollowSetting',
      path:'/vnetshop/crmFollowSetting',
      component: resolve => require(['@/components/pages/vnetshop/crmFollowSetting.vue'], resolve)
    },{
      name:'/vnetshop/crmGroupSetting',
      path:'/vnetshop/crmGroupSetting',
      component: resolve => require(['@/components/pages/vnetshop/crmGroupSetting.vue'], resolve)
    },{
      name:'/vnetshop/gyl',
      path:'/vnetshop/gyl',
      component: resolve => require(['@/components/pages/vnetshop/gyl.vue'], resolve)
    },{
      name:'/vnetshop/followStatistics',
      path:'/vnetshop/followStatistics',
      component: resolve => require(['@/components/pages/followStatistics.vue'], resolve)
    },
    {
      name:'/vnetshop/smOrder',
      path:'/vnetshop/smOrder',
      component: resolve => require(['@/components/pages/vnetshop/smOrder.vue'], resolve)
    },
    {
      name:'/vnetshop/smIncomeDaily',
      path:'/vnetshop/smIncomeDaily',
      component: resolve => require(['@/components/pages/vnetshop/smIncomeDaily.vue'], resolve)
    },
    {
      name:'/vnetshop/smCompareBill',
      path:'/vnetshop/smCompareBill',
      component: resolve => require(['@/components/pages/vnetshop/smCompareBill.vue'], resolve)
    },
    {
      name:'/vnetshop/seoSearchWord',
      path:'/vnetshop/seoSearchWord',
      component: resolve => require(['@/components/pages/vnetshop/seoSearchWord.vue'], resolve)
    },
    {
      name:'/vnetshop/seoPrice',
      path:'/vnetshop/seoPrice',
      component: resolve => require(['@/components/pages/vnetshop/seoPrice.vue'], resolve)
    },
    {
      name:'/vnetshop/seoPicture',
      path:'/vnetshop/seoPicture',
      component: resolve => require(['@/components/pages/vnetshop/seoPicture.vue'], resolve)
    },
    {
      name:'/vnetshop/warnOrderList',
      path:'/vnetshop/warnOrderList',
      component: resolve => require(['@/components/pages/vnetshop/warnOrderList.vue'], resolve)
    },
    {
      name:'/vnetshop/punishOrderList',
      path:'/vnetshop/punishOrderList',
      component: resolve => require(['@/components/pages/vnetshop/punishOrderList.vue'], resolve)
    },
    {
      name:'/vnetshop/punishOrderDetail',
      path:'/vnetshop/punishOrderDetail',
      component: resolve => require(['@/components/pages/vnetshop/punishOrderDetail.vue'], resolve)
    },
    {
      name:'/vnetshop/warnOrderDetail',
      path:'/vnetshop/warnOrderDetail',
      component: resolve => require(['@/components/pages/vnetshop/warnOrderDetail.vue'], resolve)
    },
    {
      name:'/vnetshop/seoChangJia',
      path:'/vnetshop/seoChangJia',
      component: resolve => require(['@/components/pages/vnetshop/seoChangJia.vue'], resolve)
    },
    {
      name:'/vnetshop/seoChuanDa',
      path:'/vnetshop/seoChuanDa',
      component: resolve => require(['@/components/pages/vnetshop/seoChuanDa.vue'], resolve)
    },
    {
      name:'/vnetshop/seoBaiduPush',
      path:'/vnetshop/seoBaiduPush',
      component: resolve => require(['@/components/pages/vnetshop/seoBaiduPush.vue'], resolve)
    },
    {
      name:'/vnetshop/shopMonitoringList',
      path:'/vnetshop/shopMonitoringList',
      component: resolve => require(['@/components/pages/vnetshop/shopMonitoringList.vue'], resolve)
    },
    {
      name:'/vnetshop/shopMonitoringDetail',
      path:'/vnetshop/shopMonitoringDetail',
      component: resolve => require(['@/components/pages/vnetshop/shopMonitoringDetail.vue'], resolve)
    },
    {
      name:'/vnetshop/productMonitoringList',
      path:'/vnetshop/productMonitoringList',
      component: resolve => require(['@/components/pages/vnetshop/productMonitoringList.vue'], resolve)
    },
    {
      name:'/vnetshop/shopMonitoringSum',
      path:'/vnetshop/shopMonitoringSum',
      component: resolve => require(['@/components/pages/vnetshop/shopMonitoringSum.vue'], resolve)
    },

    // {
    //   path: '/404',
    //   component: resolve => require(['@/components/page/404.vue'], resolve)
    // },
    // {
    //   path: '/403',
    //   component: resolve => require(['@/components/page/403.vue'], resolve)
    // },
    // {
    //   path: '*',
    //   redirect: '/404'
    // }
  ],
  scrollBehavior(to, from, savedPosition) {
    return {
      x: 0,
      y: 0
    }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js